/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：绑定回车功能
 * 更新记录: 
 * 1. 模态框中的保存按钮要绑定此指令的话，要在该按钮上添加类名 'modal-enter-button' 
 */
import { Directive, HostListener, ElementRef, Input } from '@angular/core';


/**
 * 绑定回车事件 触发点击
 */
@Directive({
  selector: '[SwEnterButton]'
})
export class SwEnterButtonDirective {

  /**
   * @ignore
   */
  constructor(private el: ElementRef) { }

  /**
   * @ignore
   */
  @HostListener('document:keydown', ['$event']) onkeydown(event) {
    //鉴定全屏键盘事件 如果是回车触发
    if(event.which==13){  
      if(!(event.srcElement.name =="textarea")){
        if(document.getElementsByTagName('body')[0].contains(this.el.nativeElement)){
          // console.log(document.getElementsByTagName('body')[0],this.el.nativeElement,'是模态框按钮--》',this.el.nativeElement.classList.contains("modal-enter-button"));
          if(document.getElementsByTagName('body')[0].classList.contains("modal-open")){
            //如果body上有 modal-open 这个类，就说明有模态框出现，此时只能触发模态框中的 enter 事件
            if(this.el.nativeElement.classList.contains("modal-enter-button")){
              //如果这个触发的元素是模态框中的按钮
              this.el.nativeElement.click();
            }
          } else {
            //如果没有模态框，就直接触发页面中的 enter 事件
            if(!this.el.nativeElement.classList.contains("modal-enter-button")){
              //如果这个触发的元素是模态框中的按钮
              this.el.nativeElement.click();
            }
          }
        }
      }
    }
  }
}
